import * as betgalaxy from './RaceRunnerListItem.styles.betgalaxy';
import * as betprofessor from './RaceRunnerListItem.styles.betprofessor';
import * as betroyale from './RaceRunnerListItem.styles.betroyale';
import * as fiestabet from './RaceRunnerListItem.styles.fiestabet';
import * as goldenrush from './RaceRunnerListItem.styles.goldenrush';
import * as juicybet from './RaceRunnerListItem.styles.juicybet';
import * as puntcity from './RaceRunnerListItem.styles.puntcity';
import * as puntgenie from './RaceRunnerListItem.styles.puntgenie';
import * as questbet from './RaceRunnerListItem.styles.questbet';
import * as sterlingparker from './RaceRunnerListItem.styles.sterlingparker';
import * as vikingbet from './RaceRunnerListItem.styles.vikingbet';
import * as volcanobet from './RaceRunnerListItem.styles.volcanobet';
import * as wellbet from './RaceRunnerListItem.styles.wellbet';
import * as forsport from './RaceRunnerListItem.styles.forsport';
import * as junglebet from './RaceRunnerListItem.styles.junglebet';
import * as sugarcastle from './RaceRunnerListItem.styles.sugarcastle';
import * as oldgill from './RaceRunnerListItem.styles.oldgill';
import * as buffalobet from './RaceRunnerListItem.styles.buffalobet';
import * as titanbet from './RaceRunnerListItem.styles.titanbet';
import * as slambet from './RaceRunnerListItem.styles.slambet';
import * as gigabet from './RaceRunnerListItem.styles.gigabet';
import * as betstride from './RaceRunnerListItem.styles.betstride';
import * as templebet from './RaceRunnerListItem.styles.templebet';
import * as goldenbet888 from './RaceRunnerListItem.styles.goldenbet888';
import * as hyperbet from './RaceRunnerListItem.styles.hyperbet';
import * as bet777 from './RaceRunnerListItem.styles.bet777';
import * as chromabet from './RaceRunnerListItem.styles.chromabet';
import * as bet575 from './RaceRunnerListItem.styles.bet575';
import * as epicodds from './RaceRunnerListItem.styles.epicodds';
import * as pyramidbet from './RaceRunnerListItem.styles.pyramidbet';
import * as magnumbet from './RaceRunnerListItem.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
